import { render, staticRenderFns } from "./ContactsFragmentSorting.vue?vue&type=template&id=264da92e&"
import script from "./ContactsFragmentSorting.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports